export const AUTH_COOKIE = 'auth';